
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {ApplicationActions, OfficialSignatureApiModel} from "@/api-client";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import OfficialSignature from "@/features/shared/components/OfficialSignature.vue";

    @Component({components: {OfficialSignature, HeadingGroup}})
    export default class IssueDocumentSignature extends Vue {
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        signature!: OfficialSignatureApiModel;
    }
